import React from 'react';
import styles from './AboutUsVision.module.scss';

const AboutUsVision = () => {
  return (
    <div className={styles.container}>
      {/* Left Image Section */}
      <div className={styles.content}>
        <div className={styles.heading}>
      
          Our mission at Sealkloud is to deliver exceptional SAP services that drive strategic value and operational excellence for our clients.
          <br/>
          <br/>
          We are committed to:
        </div>
       

        <ul className={styles.list}>
          <li>
            <span className={styles.icon}>✔</span> Providing tailored solutions that address the unique requirements of each client.
          </li>
          <li>
            <span className={styles.icon}>✔</span> Leveraging our extensive industry experience to deliver best-in-class architecture and solutioning.
          </li>
          <li>
            <span className={styles.icon}>✔</span> Ensuring seamless integration and adoption of SAP technologies to enhance business processes.
          </li>
          <li>
            <span className={styles.icon}>✔</span> Building long-term partnerships based on trust, transparency, and mutual success.
          </li>
          <li>
            <span className={styles.icon}>✔</span> Continuously innovating and adapting to stay ahead of industry trends and technological advancements.
          </li>
        </ul>
      </div>

      {/* Right Content Section */}
     


      <div className={styles.imageContainer}>
        <img
          src="/assests/about-us-vision.png"
          alt="Leading-Edge SAP Solutions"
          className={styles.image}
        />
      </div>
    </div>
  );
};

export default AboutUsVision;
